import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Dialog } from '@xing-com/dialog';
import { IconTrash } from '@xing-com/icons';

import * as Styled from './delete-video-button.styles';

type Props = {
  loading: boolean;
  onConfirmDialog: () => void;
};
export const DeleteVideoButton: React.FC<Props> = ({
  loading,
  onConfirmDialog,
}) => {
  const { $t } = useIntl();

  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  return (
    <>
      <Styled.DeleteVideButton
        size="medium"
        icon={IconTrash}
        loading={loading}
        onClick={() => setShowDeleteDialog(true)}
      >
        <FormattedMessage id="VIDEO_UPLOAD_DELETE" />
      </Styled.DeleteVideButton>

      <Dialog
        show={showDeleteDialog}
        isDestructive={true}
        loading={loading}
        headline={$t({
          id: 'EP_DELETE_VIDEO_DIALOG_HEADLINE',
          defaultMessage: 'EP_DELETE_VIDEO_DIALOG_HEADLINE',
        })}
        text={$t({
          id: 'EP_DELETE_VIDEO_DIALOG_TEXT',
          defaultMessage: 'EP_DELETE_VIDEO_DIALOG_TEXT',
        })}
        cancelLabel={$t({
          id: 'EP_DELETE_VIDEO_DIALOG_CANCEL',
          defaultMessage: 'EP_DELETE_VIDEO_DIALOG_CANCEL',
        })}
        confirmLabel={$t({
          id: 'EP_DELETE_VIDEO_DIALOG_CONFIRM',
          defaultMessage: 'EP_DELETE_VIDEO_DIALOG_CONFIRM',
        })}
        onCancel={() => setShowDeleteDialog(false)}
        onConfirm={() => onConfirmDialog()}
      />
    </>
  );
};
